module.exports = __webpack_public_path__ + "img/wallet_house.6e890c3f.svg";